<template>
    <div>
        <modal :name="modal_name" class="final-modal" transition="nice-modal-fade">
            <div class="v-modal-content" style="border-radius: 15px;background:#cce3fc !important;">
                <div class="pt-2 pl-0 pr-0 pb-1 m-4">
                    <div class="v-modal-body pt-0 pb-0" style="max-height: 410px;overflow-x: hidden;overflow-y: auto;">
                        <div class="d-form" style="overflow: initial !important;">
                            <div  class="text-center">
                                <img src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/dog.svg" alt="Delete Icon">
                                <div class="text-dark fw-500 fs-20 pt-2 pb-2">{{reasonTicketAccess || '-'}}</div>
                                <div class="text-dark fs-16 pt-2 pb-2">Please Wait...........</div>
                            </div>
                        </div>
                    </div>
                    <div class="v-modal-dialog-actions" style="border-radius: 0px 0px 15px 15px;">
                        <button type="button" class="btn btn-secondary btn-smm ml-3" style="box-shadow: none;" @click="cancel()">
                            Ok
                        </button>
                    </div>
                </div>
            </div>
        </modal>
    </div>  
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event'
export default {
    props:['modal_name','reasonTicketAccess'],
    data(){
        return{

        }
    },
    methods:{
        cancel(){
            this.$modal.hide(this.modal_name);
        },
    }
}
</script>
<style scoped>

</style>